<template>
  <div class="h-100 pb-3">
    <object-grid
      model-class="CompanyLocation"
      flow-subtype=""
      class="h-100"
      grid-max-height="100%"
      :colStateLocalStorageKey="'vendorProfileLocations'"
      :fixedFilterKwargs="fixedFilterKwargs"
      :excludeFields="excludeFields"
    ></object-grid>
  </div>
</template>

<script>
  export default {
    name: 'VendorLocationsGrid',
    props: {
      resource: {
        type: Object,
        required: true,
      },
    },
    mixins: [],
    data() {
      return {
        excludeFields: ['parent'],  // this works now because we are using fixedFilterKwargs
        fixedFilterKwargs: {
          parent: this.resource.id,
        },
      };
    },
    computed: {},
    mounted() {},
    methods: {},
  };
</script>
